import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getDetailsUseCase } from '@/core/domain/details/usecases/getDetails.usecase';
import { DetailsRepository } from '@/core/domain/details/repositories/details.repository';
import { DetailsImplRepository } from './details-impl.repository';

const getDetailsUseCaseFactory = (detailsRepository: DetailsRepository) =>
    new getDetailsUseCase(detailsRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: getDetailsUseCase,
            useFactory: getDetailsUseCaseFactory,
            deps: [DetailsRepository],
        },
        {
            provide: DetailsRepository,
            useClass: DetailsImplRepository,
        },
    ],
})
export class DetailsDataModule {}
